<div class="flex justify-between gap-[48px] pt-6 pb-6">
    <div>
        <button
            mat-stroked-button
            id="previous-page-btn"
            data-testid="previous-page-btn"
            class="ca-button mt-auto"
            [disabled]="disabled || pageIndex === 0"
            (click)="onNavigationClick(-1)"
        >
            <mat-icon class="m-0">navigate_before</mat-icon>
        </button>
    </div>

    <div class="hidden sm:flex justify-center gap-2 pages">
        @for (index of pageIndexes; track index) {
            @if (index === -1) {
                <div data-testid="paginator-bar-dots" class="flex items-center justify-center dots">...</div>
            } @else {
                <button
                    mat-stroked-button
                    id="page-{{ index + 1 }}-btn"
                    [attr.data-testid]="'page-' + (index + 1) + '-btn'"
                    class="ca-button mt-auto page-btn"
                    [class.active-page]="pageIndex === index"
                    (click)="onPageClick(index)"
                    [disabled]="disabled"
                >
                    {{ index + 1 }}
                </button>
            }
        }
    </div>

    <div data-testid="paginator-bar-page" class="flex sm:hidden items-center justify-center pages">
        {{ 'PAGINATOR_BAR.PAGE' | translate }} {{ pageIndex + 1 }}/{{ totalPagesCount }}
    </div>

    <div>
        <button
            mat-stroked-button
            id="next-page-btn"
            data-testid="next-page-btn"
            class="ca-button mt-auto"
            [disabled]="disabled || pageIndex === totalPagesCount - 1"
            (click)="onNavigationClick(1)"
        >
            <mat-icon class="m-0">navigate_next</mat-icon>
        </button>
    </div>
</div>
